import { render, staticRenderFns } from "./LayoutPortal.vue?vue&type=template&id=74983c9e&scoped=true"
import script from "./LayoutPortal.vue?vue&type=script&lang=js"
export * from "./LayoutPortal.vue?vue&type=script&lang=js"
import style0 from "./LayoutPortal.vue?vue&type=style&index=0&id=74983c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74983c9e",
  null
  
)

export default component.exports